
import { mapGetters, mapState, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin, ValidacaoMixin } from "@/modules/Application";
import { store } from "../../storeLogistica";
import VueSelect from "vue-select";
import _ from "lodash";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
import { mask } from "vue-the-mask";

export default {
  name: "app-mdfe-form-pedagioTab",
  components: {
    VueSelect,
    Money,
  },
  directives: {
    mask,
  },
  data() {
    return {
      store,
      configMoney: settingMoney,
      form: {
        tipo_pedagio: null,
        numero_compra: null,
        valor: null,
        identificao_responsavel: null,
        tipo_combinacao_veiculo: null,
        observacoes: null,
        responsavel: {
          cnpj: null,
        }
      },

      tipoPedagioError: false,
      unidadeError: false,
      tiposPedagio: [],
      combinacoesVeiculares: [],
    }
  },
  mixins: [
    validationMixin,
    SistemaMixin,
    ValidacaoMixin,
  ],
  methods: {
    ...mapActions(["setLoading"]),
    async getDataInit() {
      const mdfeData = this.$route.params?.mdfeData?.mdfe;
      const [{ data: pedagioTiposData }, { data: combinacoesVeicularesData }] = await Promise.all([
        this.$http.post('/mdfe/get-pedagio-tipo'),
        this.$http.post('/mdfe/get-combinacao-veicular'),
      ])
      this.tiposPedagio = pedagioTiposData;
      this.combinacoesVeiculares = combinacoesVeicularesData;
      console.log(mdfeData);
      this.form.observacoes = mdfeData?.observacoes ?? ''
      if (mdfeData) {
        this.form.valor = mdfeData.pedagio[0].valor;
        this.form.numero_compra = mdfeData.pedagio[0].numero_compra;
        this.form.tipo_combinacao_veiculo = combinacoesVeicularesData.find(combinacao => combinacao.id = mdfeData.pedagio[0].tipo_combinacao_veiculo);
        this.form.tipo_pedagio = pedagioTiposData.find(pedagio => pedagio.id = mdfeData.pedagio[0].tipo_pedagio);
        this.form.identificao_responsavel = mdfeData.pedagio[0].identificao_responsavel;
        this.form.responsavel = mdfeData.pedagio[0].responsavel;
      }
    },
    onSearchUnidades(search, loading) {
      if (search.length) {
        loading(true);
        this.searchUnidades(loading, search, this);
      }
    },
    searchUnidades: _.debounce(async (loading, nome, vm) => {
      const { data } = await vm.$http.post('/produtos/get-unidade-medida', { nome });
      vm.combinacoesVeiculares = data;
      if (loading) loading(false);
    }, 350),
    validateState(field) {
      return !!this.form[field];
    }
  },
  created() {
    this.getDataInit();
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig"
    ]),
    ...mapState(["loading"]),
    isLoading() {
      return this.loading.loading;
    },
    isTheCurrentTab() {
      return store.currentTab === 6
    }
  },
  watch: {
    form: {
      handler(form) {
        this.store.formData = {
          ...this.store.formData,
          observacoes: this.form.observacoes,
          pedagio: [{
            tipo_combinacao_veiculo: this.form.tipo_combinacao_veiculo?.id ?? null,
            tipo_pedagio: form.tipo_pedagio?.id ?? null,
            numero_compra: this.form.numero_compra,
            valor: this.form.valor,
            identificao_responsavel: this.form.identificao_responsavel,
            responsavel: this.form.responsavel
          }],
        }
      }, deep: true
    }
  }
}

